export default __webpack_public_path__ + "static/media/Jerkin of the Death Master.83bdbf2e.jpg";